<template>
  <h2 class="titleStepForm mb-2">
    Politically Exposed Persons <sup>(PEPs)</sup>
  </h2>
  <p class="subTitleForm text-center">
    <template v-if="isPdf">
    Individuals who are or have been entrusted with
    prominent functions by an international/ local
    organization such as:
    </template>
    <template v-if="!isPdf">
    Individuals who are or have been entrusted with prominent
    functions by an international/ local organization such as:
    </template>
  </p>
  <div class="formContentPoli mb-3">
    <h3 class="font-size-22 mb-4 mt-5 text-center">
      Please tick the one(s) that apply
    </h3>
    <p>
      A <strong>“politically exposed person”</strong> (PEP)
      <template v-if="isPdf">
      means a person who is or was entrusted with a
      prominent function by an international/ local
      organization or important political functions such as:
      </template>
      <template v-if="!isPdf">
      means a person who is or was entrusted with a prominent
      function by an international/ local organization or
      important political functions such as:
      </template>
    </p>
    <h5>International Organization:</h5>
    <p>
      Members of senior management such as directors and
      members of the board or equivalent function. United
      Nations and affiliated international organizations,
      Organization of America States, Inter-American
      <template v-if="isPdf">
      Development Bank, International Labour Organization,
      and Caribbean Financial Action Task Force.
      </template>
      <template v-if="!isPdf">
      Development Bank, International Labour Organization, and
      Caribbean Financial Action Task Force.
      </template>
    </p>
    <h5>Government:</h5>
    <p>
      Head of State, senior politician, senior government
      official, judicial or military officials, and senior
      executives of State owned corporations and important
      <template v-if="isPdf">
      political party officials. Senior government
      officials- e.g. Permanent Secretary, Accounting
      Officer, Chief Technical Officer, High Commissioner
      Senior executives of state corporations e.g. Board
      members of all Statutory Bodies. Senior political
      party officials e.g. Chairman, Deputy Chairman,
      Secretary and Treasurer, Judicial Official e.g.
      Judges, magistrates, Military Officials e.g. a
      Lieutenant Colonel or higher rank.
      </template>
      <template v-if="!isPdf">
      political party officials. Senior government officials-
      e.g. Permanent Secretary, Accounting Officer, Chief
      Technical Officer, High Commissioner Senior executives
      of state corporations e.g. Board members of all
      Statutory Bodies. Senior political party officials e.g.
      Chairman, Deputy Chairman, Secretary and Treasurer,
      Judicial Official e.g. Judges, magistrates, Military
      Officials e.g. a Lieutenant Colonel or higher rank.
      </template>
    </p>
    <p>
      An immediate family member or any individual publicly
      known or actually known to the relevant financial
      institution to be associated with a PEP.
    </p>
    <p>Are you or have you ever been:</p>
  </div>
  <div class="groupFormStyle">
    <div class="mb-3">
      <h3 class="font-size-15">
        (a) Entrusted with a prominent function referred to
        above
      </h3>
      <div class="row">
        <div class="col-auto">
          <label
            for="yesEntrust"
            class="w-100 b-0 p-relative labelStyleRadioCstm pt-2 pb-2"
            :class="{
              'is-invalid':
                v$.form.personal.entrustedRadio.$error,
            }"
          >
            <input
              type="radio"
              v-model="form.personal.entrustedRadio"
              value="true"
              class="inputRadioCstm d-none"
              id="yesEntrust"
              disabled
            />
            <span class="radioCircleIcon">
              <i
                class="mdi mdi-circle-outline text-theme font-size-20"
              ></i>
              <i
                class="mdi mdi-checkbox-marked-circle text-theme theme-check font-size-20"
              ></i>
            </span>
            <h4
              class="font-size-14 text-dark-custom mb-0 ms-1"
            >
              Yes
            </h4>
          </label>
          <div
            v-for="(personal, index) in v$.form.personal
              .entrustedRadio.$errors"
            :key="index"
            class="invalid-feedback"
          >
            <span v-if="personal.$message">{{
              personal.$message
            }}</span>
          </div>
        </div>
        <div class="col-auto">
          <label
            for="noEntrust"
            class="w-100 b-0 p-relative labelStyleRadioCstm pt-2 pb-2"
            :class="{
              'is-invalid':
                v$.form.personal.entrustedRadio.$error,
            }"
          >
            <input
              type="radio"
              v-model="form.personal.entrustedRadio"
              value="false"
              class="inputRadioCstm d-none"
              id="noEntrust"
              disabled
            />
            <span class="radioCircleIcon">
              <i
                class="mdi mdi-circle-outline text-theme font-size-20"
              ></i>
              <i
                class="mdi mdi-checkbox-marked-circle text-theme theme-check font-size-20"
              ></i>
            </span>
            <h4
              class="font-size-14 text-dark-custom mb-0 ms-1"
            >
              No
            </h4>
          </label>
          <div
            v-for="(personal, index) in v$.form.personal
              .entrustedRadio.$errors"
            :key="index"
            class="invalid-feedback"
          >
            <span v-if="personal.$message">{{
              personal.$message
            }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="mb-3">
      <h3 class="font-size-15">
        <template v-if="isPdf">
        (b) an immediate family member of a person referred
        to above (a) such as the spouse, parent, siblings,
        </template>
        <template v-if="!isPdf">
        (b) an immediate family member of a person referred to
        above (a) such as the spouse, parent, siblings,
        </template>
        children and children of the spouse of that person;
      </h3>
      <div class="row">
        <div class="col-auto">
          <label
            for="yesMember"
            class="w-100 b-0 p-relative labelStyleRadioCstm pt-2 pb-2"
            :class="{
              'is-invalid':
                v$.form.personal.memberOfRadio.$error,
            }"
          >
            <input
              type="radio"
              v-model="form.personal.memberOfRadio"
              value="true"
              class="inputRadioCstm d-none"
              id="yesMember"
              disabled
            />
            <span class="radioCircleIcon">
              <i
                class="mdi mdi-circle-outline text-theme font-size-20"
              ></i>
              <i
                class="mdi mdi-checkbox-marked-circle text-theme theme-check font-size-20"
              ></i>
            </span>
            <h4
              class="font-size-14 text-dark-custom mb-0 ms-1"
            >
              Yes
            </h4>
          </label>
          <div
            v-for="(personal, index) in v$.form.personal
              .memberOfRadio.$errors"
            :key="index"
            class="invalid-feedback"
          >
            <span v-if="personal.$message">{{
              personal.$message
            }}</span>
          </div>
        </div>
        <div class="col-auto">
          <label
            for="noMember"
            class="w-100 b-0 p-relative labelStyleRadioCstm pt-2 pb-2"
            :class="{
              'is-invalid':
                v$.form.personal.memberOfRadio.$error,
            }"
          >
            <input
              type="radio"
              v-model="form.personal.memberOfRadio"
              value="false"
              class="inputRadioCstm d-none"
              id="noMember"
              disabled
            />
            <span class="radioCircleIcon">
              <i
                class="mdi mdi-circle-outline text-theme font-size-20"
              ></i>
              <i
                class="mdi mdi-checkbox-marked-circle text-theme theme-check font-size-20"
              ></i>
            </span>
            <h4
              class="font-size-14 text-dark-custom mb-0 ms-1"
            >
              No
            </h4>
          </label>
          <div
            v-for="(personal, index) in v$.form.personal
              .memberOfRadio.$errors"
            :key="index"
            class="invalid-feedback"
          >
            <span v-if="personal.$message">{{
              personal.$message
            }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="mb-3">
      <h3 class="font-size-15">
        <template v-if="isPdf">
        (C) a close personal or professional associate of
        the persons referred to above (a) or (b)
        </template>
        <template v-if="!isPdf">
        (C) a close personal or professional associate of the
        persons referred to above (a) or (b)
        </template>
      </h3>
      <div class="row">
        <div class="col-auto">
          <label
            for="yesReferred"
            class="w-100 b-0 p-relative labelStyleRadioCstm pt-2 pb-2"
            :class="{
              'is-invalid':
                v$.form.personal.referredRadio.$error,
            }"
          >
            <input
              type="radio"
              v-model="form.personal.referredRadio"
              value="true"
              class="inputRadioCstm d-none"
              id="yesReferred"
              disabled
            />
            <span class="radioCircleIcon">
              <i
                class="mdi mdi-circle-outline text-theme font-size-20"
              ></i>
              <i
                class="mdi mdi-checkbox-marked-circle text-theme theme-check font-size-20"
              ></i>
            </span>
            <h4
              class="font-size-14 text-dark-custom mb-0 ms-1"
            >
              Yes
            </h4>
          </label>
          <div
            v-for="(personal, index) in v$.form.personal
              .referredRadio.$errors"
            :key="index"
            class="invalid-feedback"
          >
            <span v-if="personal.$message">{{
              personal.$message
            }}</span>
          </div>
        </div>
        <div class="col-auto">
          <label
            for="noReferred"
            class="w-100 b-0 p-relative labelStyleRadioCstm pt-2 pb-2"
            :class="{
              'is-invalid':
                v$.form.personal.referredRadio.$error,
            }"
          >
            <input
              type="radio"
              v-model="form.personal.referredRadio"
              value="false"
              class="inputRadioCstm d-none"
              id="noReferred"
              disabled
            />
            <span class="radioCircleIcon">
              <i
                class="mdi mdi-circle-outline text-theme font-size-20"
              ></i>
              <i
                class="mdi mdi-checkbox-marked-circle text-theme theme-check font-size-20"
              ></i>
            </span>
            <h4
              class="font-size-14 text-dark-custom mb-0 ms-1"
            >
              No
            </h4>
          </label>
          <div
            v-for="(personal, index) in v$.form.personal
              .referredRadio.$errors"
            :key="index"
            class="invalid-feedback"
          >
            <span v-if="personal.$message">{{
              personal.$message
            }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="border-top pt-3">
      <h4 class="text-center font-size-14 mb-0">
        If you have answered “yes” to any of the questions
        above, Enhanced Due Diligence Form to be completed
      </h4>
    </div>
  </div>
</template>

<script>
import { bridge } from "../formBridge";

export default {
  name: "ReviewPep",
  props: {
    variant: { type: String, default: "review" },
  },
  computed: {
    isPdf() {
      return this.variant === "pdf";
    },
  },
  mixins: [
    bridge({
    state: ["form"],
    validate: true,
    }),
  ],
};
</script>
